<mat-nav-list style="max-width: 250px; background-color: white;">

  <ng-container>

    <form [formGroup]="formGroup">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <!--Selector administración-->
        <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin-bottom: -15px;">
          <mat-form-field appearance="outline" style="width: 100%; color: white;">
            <mat-label *ngIf="!isTenantSearching">Mi {{ getDiccionarioTraduccion('Tenant') }}</mat-label>
            <mat-label *ngIf="isTenantSearching">Cargando...</mat-label>
            <mat-select formControlName="Tenant" (selectionChange)="onTenantSelect(true)"
              [disabled]="tenantList != null && tenantList.length == 1">
              <mat-option *ngFor="let s of tenantList" [value]="s.Id">
                <img with="12" height="12" src="{{s.LogoUrl}}" style="margin-right: 5px;"> {{s.NombreCorto}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!--Selector Consorcio-->
        <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="showConsorcios()" style="margin-bottom: -15px;">
          <mat-form-field appearance="outline" style="width: 100%; color: white;">
            <mat-label *ngIf="!isConsorcioSearching">Mi {{ getDiccionarioTraduccion('Consorcio') }}</mat-label>
            <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
            <mat-select formControlName="Consorcio" (selectionChange)="onConsorcioSelect()">
              <mat-option [value]="0">Ver Todos</mat-option>
              <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!--Selector comunidades/edificios-->
        <!--<div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="showComunidades()" style="margin-bottom: -15px;">
          <mat-form-field appearance="outline" style="width: 100%; color: white;">
            <mat-label *ngIf="!isComunidadSearching">Mi {{ getDiccionarioTraduccion('Comunidad') }}</mat-label>
            <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
            <mat-select formControlName="Comunidad" (selectionChange)="onComunidadSelect()">
              <mat-option [value]="0">Ver Todos</mat-option>
              <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->

        <hr style="width: 90%; background-color: white; color: white;">

      </div>

    </form>

  </ng-container>

  <div appearance="outline" fxLayout="row stretch"
    style="justify-content: flex-start; height: 2.5rem; margin: 0rem 1rem; border: 1px solid #d1d1d1; border-radius: 7px; padding: 10px;"> 
    <input style="margin-top: -3px !important; border: none; width: 85%; outline: none;" matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange($event)"
      class="text-style" placeholder="Buscar puntos de menú">
    <mat-icon class="matSuffix" style="margin: -2px 0px 0px 0px !important; padding: 0px !important;" matSuffix *ngIf="searchTerm && searchTerm.length > 0" 
      (click)="clearSearchTerm()" title="Limpiar búsqueda">clear</mat-icon>
    <mat-icon class="matSuffix" style="margin: -2px 0px 0px 0px !important; padding: 0px !important;" matSuffix *ngIf="!(searchTerm && searchTerm.length > 0)">search</mat-icon>
  </div>

  <ng-container *ngFor="let item of menu">
    <ng-container *ngIf="!searchTerm || matchesSearchTerm(item) || isParentExpanded(item)">
      <ng-container  *ngTemplateOutlet="Recursion; context: { item: item }"></ng-container>
    </ng-container>
  </ng-container>

</mat-nav-list>

<ng-template #Recursion let-item="item">

  <ng-container *ngIf="validateMenu(item)">

    <a mat-list-item *ngIf="!hasMenuChildren(item)" routerLink="{{item.Link}}" routerLinkActive="list-item-active" (click)="clearSearchTerm()">
      <i class="fa {{item.Icono}}" *ngIf="showMenuIcon(item)" aria-hidden="true"
        style="margin-right: 5px;"></i>{{item.Nombre}}
    </a>

    <mat-expansion-panel mat-list-item *ngIf="hasMenuChildren(item)" class="expansion">

      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="fa {{item.Icono}}" aria-hidden="true" *ngIf="showMenuIcon(item)"
            style="margin-right: 5px;"></i>{{item.Nombre}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let subitem of item.MenuHijos">
        <ng-container *ngIf="!searchTerm || matchesSearchTermChildren(subitem)">
          <ng-container *ngTemplateOutlet="Recursion; context: { item: subitem }"></ng-container>
        </ng-container>
      </ng-container>

    </mat-expansion-panel>

  </ng-container>

</ng-template>